<template>
  <van-picker show-toolbar :columns="columns" @change="onChange" @confirm="onConfirm" @cancel="onCancel" ref="picker" />
</template>

<script>
import Vue from 'vue';
import { Picker } from 'vant';
Vue.use(Picker);
export default {
  name: "DatetimePicker",
  model:{
    prop:'value',
  },
  data(){
    return {
      now:new Date(),
      nowYear:0,
      nowMonth:0,
      yearIndex:0,
      monthIndex:0,
      dayIndex:0,
      years:[],
      months:[],
      days:[],
      year:0,
      month:0,
      day:0,
      columns:[
        {
          values:[],
          defaultIndex:0
        },
        {
          values:[],
          defaultIndex:0
        },
        {
          values:[],
          defaultIndex:0
        }
      ],
    }
  },
  props: {
    value:Date,
    minDate: {
      type: Date,
      default: Date.parse('1950-01-01')
    },
    maxDate: {
      type: Date,
      default: new Date()
    },
    formatter:{
      type:Function,
      default:function (type, val)
      {
        return val;
      }
    },
    showToNow:{
      type:Boolean,
      default:false
    },
    confirmButtonText:{
      type:String,
      default:'确认'
    },
    cancelButtonText:{
      type:String,
      default:'取消'
    },
  },
  mounted: function() {
    this.init();
  },
  watch:{
    value(n,o)
    {
      if(this.ok)
      {
        this.ok=false;
        return;
      }
      if(n.getFullYear()!=o.getFullYear() || n.getMonth()!=o.getMonth() || n.getDate()!=o.getDate())
      {
        this.value=n;
        this.init();
      }
    }
  },
  methods: {
    init()
    {
      this.now=new Date();
      this.nowYear=this.now.getFullYear();
      this.nowMonth=this.now.getMonth()+1;
      this.nowDay=this.now.getDate();
      let valueYear=this.nowYear;
      let valueMonth=this.nowMonth;
      let valueDay=this.nowDay;
      let minYear= this.minDate.getFullYear();
      let maxYear=this.maxDate.getFullYear();
      let minMonth=1;
      let maxMonth=12;
      let minDay=1;
      let maxDay=30;
      if(this.value && this.value!='至今')
      {
        valueYear=this.value.getFullYear();
        valueMonth=this.value.getMonth()+1;
        valueDay=this.value.getDate();
        if(valueYear<minYear)
        {
          minYear=valueYear;
        }
        if(valueYear>maxYear)
        {
          maxYear=valueYear;
        }
      }
      let years=[];
      let months=[];
      let days=[];
      let year=0;
      let month=0;
      let day=0;
      let yearIndex=-1;
      let monthIndex=-1;
      let dayIndex=-1;
      //年
      for(let y=minYear,yi=0;y<=maxYear;y++,yi++)
      {
        let yy=this.formatter?this.formatter('year',y):y;
        years.push(yy);
        if(valueYear==y)
        {
          yearIndex=yi;
          year=y;
        }
      }
      if(this.showToNow)
      {
        years.push('至今');
      }
      if(this.value!='至今')
      {
        if(yearIndex==-1)
        {
          year=maxYear;
          yearIndex=years.length-1;
        }
        //月
        if (valueYear == minYear) {
          minMonth = this.minDate.getMonth() + 1;
        }
        if (valueYear == maxYear) {
          maxMonth = this.maxDate.getMonth() + 1;
        }
        for (let m = minMonth, mi = 0; m <= maxMonth; m++, mi++)
        {
          let mm=this.formatter?this.formatter('month',(''+m).padStart(2,'0')):(''+m).padStart(2,'0');
          months.push(mm);
          if (yearIndex != 1 && m == valueMonth) {
            month = m;
            monthIndex = mi;
          }
        }
        if (monthIndex == -1) {
          year = maxYear;
          monthIndex = 0;
          month = 1;
        }
        //天
        maxDay = new Date(year, month, 0).getDate();
        if (valueYear == minYear && valueMonth == (this.minDate.getMonth() + 1)) {
          minDay = this.minDate.getDate();
        }
        if (valueYear == maxYear && valueMonth == (this.maxDate.getMonth() + 1)) {
          maxDay = this.maxDate.getDate();
        }
        for (let d = minDay, di = 0; d <= maxDay; d++, di++) {
          let dd=this.formatter?this.formatter('day',(''+d).padStart(2,'0')):(''+d).padStart(2,'0');
          days.push(dd);
          if (yearIndex != 1 && d == valueDay) {
            day = d;
            dayIndex = di;
          }
        }
        if (yearIndex == -1) {
          yearIndex = years.length - 1;
          day = 1;
          dayIndex = 0;
        }
      }
      else
      {
        yearIndex=years.length-1;
        year='至今';
      }
      this.years=years;
      this.months=months;
      this.days=days;
      this.year=year;
      this.month=month;
      this.day=day;
      this.yearIndex=yearIndex;
      this.monthIndex=monthIndex;
      this.dayIndex=dayIndex;
      this.columns=[{
        values:years,
        defaultIndex:this.yearIndex
      },{
        values:months,
        defaultIndex:this.monthIndex
      },{
        values:days,
        defaultIndex:this.dayIndex
      }];
    },
    onCancel(values){
      this.$emit('cancel');
    },
    onConfirm(values){
      //this.confirm && this.confirm(this.year=='至今'?this.year:new Date(this.year,this.month-1,this.day));
      let date=this.year=='至今'?this.year:new Date(this.year,this.month-1,this.day);
      this.ok=true;
      this.$emit('confirm', date);
    },
    onChange(picker, values)
    {
      //console.log('onChange',values)
      this.setColumns(picker,values);
      this.$emit("change",this,values);
    },
    setColumns(picker,values) {
      let curyear = values[0];
      let curmonth =values[1];
      let curday = values[2];
      let year = 0;
      let month = 0;
      let day = 0;
      let yearIndex = -1;
      let monthIndex = -1;
      let dayIndex = -1;
      let years = this.years;
      let months = [];
      let days = [];
      let minYear = this.minDate.getFullYear();
      let maxYear = this.maxDate.getFullYear();
      let minMonth = 1;
      let maxMonth = 12;
      let minDay = 1;
      let maxDay = 30;
      for (let yi = 0; yi < years.length; yi++) {
        if (years[yi] == curyear)
        {
          yearIndex = yi;
          break;
        }
      }
      if(curyear!='至今')
      {
        let valueYear = parseInt(curyear);
        let valueMonth = parseInt(curmonth);
        let valueDay = parseInt(curday);
        year=valueYear;
        //月
        if (valueYear == minYear)
        {
          minMonth = this.minDate.getMonth() + 1;
        }
        if (valueYear == maxYear) {
          maxMonth = this.maxDate.getMonth() + 1;
        }
        for (let m = minMonth, mi = 0; m <= maxMonth; m++, mi++) {
          let mm = this.formatter ? this.formatter('month', ('' + m).padStart(2, '0')) : ('' + m).padStart(2, '0');
          months.push(mm);
          if (yearIndex != 1 && m == valueMonth) {
            month = m;
            monthIndex = mi;
          }
        }
        if (monthIndex == -1) {
          year = maxYear;
          monthIndex = 0;
          month = 1;
        }
        //天
        maxDay = new Date(year, month, 0).getDate();
        if (valueYear == minYear && valueMonth == (this.minDate.getMonth() + 1)) {
          minDay = this.minDate.getDate();
        }
        if (valueYear == maxYear && valueMonth == (this.maxDate.getMonth() + 1)) {
          maxDay = this.maxDate.getDate();
        }
        for (let d = minDay, di = 0; d <= maxDay; d++, di++) {
          let dd = this.formatter ? this.formatter('day', ('' + d).padStart(2, '0')) : ('' + d).padStart(2, '0');
          days.push(dd);
          if (yearIndex != 1 && d == valueDay) {
            day = d;
            dayIndex = di;
          }
        }
        if (yearIndex == -1) {
          yearIndex = years.length - 1;
          day = 1;
          dayIndex = 0;
        }
      }
      else
      {
        year='至今';
      }
      this.months = months;
      this.days = days;
      this.year = year;
      this.month = month;
      this.day = day;
      this.yearIndex = yearIndex;
      this.monthIndex = monthIndex;
      this.dayIndex = dayIndex;
      this.columns = [{
        values: years,
        defaultIndex: this.yearIndex
      }, {
        values: months,
        defaultIndex: this.monthIndex
      }, {
        values: days,
        defaultIndex: this.dayIndex
      }];
      picker.setColumnValues(1, months);
      picker.setColumnValues(2, days);
    },
    getValues(){
      if(this.year=='至今')
      {
        return [this.year,'',''];
      }
      let yy=this.formatter?this.formatter('year',this.year):this.year;
      let mm=this.formatter?this.formatter('month',(''+this.month).padStart(2,'0')):(''+this.month).padStart(2,'0');
      let dd=this.formatter?this.formatter('day',(''+this.day).padStart(2,'0')):(''+this.day).padStart(2,'0');
      return [yy,mm,dd];
    },
    setValues(values)
    {
      this.setColumns(this.$refs.picker,values);
      this.$refs.picker.setValues(values);
    }
  }
}
</script>

<style scoped>

</style>